<template>
  <v-app>
    <Header
      system-name="ระบบสารสนเทศเพื่อการบริหาร"
      :program-name = programName
      background-color="orange darken-2"
      systemDate="17 ม.ค. 2561"/>
    <MenuNav style="margin-top: 84px" />
    <v-content style="padding: 10px 10px 0px 10px">
      <transition name="component-fade" mode="out-in">
        <router-view/>
      </transition>
    </v-content>
    <Loading ref="loading2"/>
    <AlertBox ref="alertBox" />
  </v-app>
</template>

<script>
export default {
  name: 'App',
  data () {
    return {
      currentComponent: null,
      clerkName: null,
      OfficerName: null,
      workPlace: null,
      programName: null
    }
  },
  mounted () {
    this.$store.state.loading2 = this.$refs.loading2
    this.$store.state.alertBox = this.$refs.alertBox
  },
  updated () {
    if (this.$route.name === 'ReportStat') {
      this.programName = 'สถิติประชากร รายจังหวัด'
    } else if (this.$route.params.id === '2') {
      this.programName = 'สถิติประชากร รายอำเภอ'
    } else if (this.$route.params.id === '3') {
      this.programName = 'สถิติประชากรรายจังหวัดตามช่วงอายุที่ระบุ'
    } else if (this.$route.params.id === '4') {
      this.programName = 'สถิติอัตราการตายต่ออัตราการเกิด รายจังหวัด'
    } else if (this.$route.params.id === '5') {
      this.programName = 'สถิติอัตราการแจ้งย้ายเข้าต่ออัตราการแจ้งย้ายออก รายจังหวัด'
    } else if (this.$route.name === 'ReportTenYear') {
      if (this.$route.params.id === '1') {
        this.programName = 'แสดงข้อมูลอัตราการเพิ่มลดของประชากร'
      } else if (this.$route.params.id === '2') {
        this.programName = 'แสดงข้อมูลอัตราการเพิ่มลดของบุคคลไม่ได้สัญชาติไทย'
      } else if (this.$route.params.id === '3') {
        this.programName = 'แสดงข้อมูลอัตราการเกิด'
      } else if (this.$route.params.id === '4') {
        this.programName = 'แสดงข้อมูลอัตราการตาย'
      } else if (this.$route.params.id === '5') {
        this.programName = 'แสดงข้อมูลอัตราการเกิดเปรียบเทียบกับอัตราการตายในรอบ 10 ปี'
      } else if (this.$route.params.id === '6') {
        this.programName = 'แสดงข้อมูลอัตราการเกิดมากกว่าอัตราการตายในรอบ 10 ปี'
      } else if (this.$route.params.id === '7') {
        this.programName = 'แสดงข้อมูลอัตราการเพิ่มลดของจำนวนบ้าน'
      } else if (this.$route.params.id === '8') {
        this.programName = 'แสดงข้อมูลการออกบัตร'
      }
    } else if (this.$route.name === 'ReportTopTen') {
      if (this.$route.params.id === '1') {
        this.programName = 'จังหวัดที่มีประชากร มากที่สุด 10 ลำดับ'
      } else if (this.$route.params.id === '2') {
        this.programName = 'จังหวัดที่มีประชากร น้อยที่สุด 10 ลำดับ'
      } else if (this.$route.params.id === '3') {
        this.programName = 'จังหวัดที่มีบุคคลไม่ได้สัญชาติไทย มากที่สุด 10 ลำดับ'
      } else if (this.$route.params.id === '4') {
        this.programName = 'จังหวัดที่มีการเกิด มากที่สุด 10 ลำดับ'
      } else if (this.$route.params.id === '5') {
        this.programName = 'จังหวัดที่มีการเกิด น้อยที่สุด 10 ลำดับ'
      } else if (this.$route.params.id === '6') {
        this.programName = 'จังหวัดที่มีการตาย มากที่สุด 10 ลำดับ'
      } else if (this.$route.params.id === '7') {
        this.programName = 'จังหวัดที่มีการตาย น้อยที่สุด 10 ลำดับ'
      } else if (this.$route.params.id === '8') {
        this.programName = 'จังหวัดที่มีการแจ้งย้ายเข้า มากที่สุด 10 ลำดับ'
      } else if (this.$route.params.id === '9') {
        this.programName = 'จังหวัดที่มีการแจ้งย้ายเข้า น้อยที่สุด 10 ลำดับ'
      } else if (this.$route.params.id === '10') {
        this.programName = 'จังหวัดที่มีการแจ้งย้ายออก มากที่สุด 10 ลำดับ'
      } else if (this.$route.params.id === '11') {
        this.programName = 'จังหวัดที่มีการแจ้งย้ายออก น้อยที่สุด 10 ลำดับ'
      }
    }
  }
}
</script>

<style>
@font-face{
  font-family: 'CSChatThaiUI';
  src: url('./fonts/CSChatThaiUI.woff') format("woff");
  }

  *{
    font-family: 'CSChatThaiUI';
    font-size: 14px;
  }

  .component-fade-enter-active,
.component-fade-leave-active {
  transition: opacity 0.2s ease;
}
.component-fade-enter,
.component-fade-leave-to {
  opacity: 0;
}

hr {
  background-color: #f57c00;
  height: 2px;
  border: none;
}
label {
  color: #f57c00;
  font-weight: bold;
}
.v-input input,
.v-menu__activator {
  max-height: 32px;
}
.v-input .v-label {
  width: auto;
  font-size: 16px;
  color: #000;
  /* color:#673AB7; */
}
.v-text-field .v-label--active {
  max-width: none;
  font-size: 16px;
}
.v-text-field {
  margin-top: 8px;
}
.v-textarea.v-text-field--box.v-text-field--single-line .v-text-field__prefix,
.v-textarea.v-text-field--box.v-text-field--single-line textarea,
.v-textarea.v-text-field--enclosed.v-text-field--single-line
  .v-text-field__prefix,
.v-textarea.v-text-field--enclosed.v-text-field--single-line textarea {
  margin-top: 0px;
}
.v-input--radio-group .v-input__control .v-input__slot {
  margin-bottom: 0px;
}
.v-radio {
  align-items: flex-start;
}
.v-text-field .v-input__control .v-text-field__details,
.v-messages {
  display: none;
}
.select-label .v-select__selection {
  color: #f57c00;
}
.v-select > .v-input__control > .v-input__slot {
  min-height: 32px;
}
.v-text-field .v-label {
  width: auto;
  color: #f57c00;
  font-size: 16px;
  line-height: 26px !important;
  height: auto;
}
.v-text-field .v-label--active {
  max-width: none;
  font-size: 16px;
}
.v-textarea.v-text-field--box.v-text-field--single-line .v-text-field__prefix,
.v-textarea.v-text-field--box.v-text-field--single-line textarea,
.v-textarea.v-text-field--enclosed.v-text-field--single-line
  .v-text-field__prefix,
.v-textarea.v-text-field--enclosed.v-text-field--single-line textarea {
  margin-top: 0px;
}
.headLable {
  color: #000000;
  font-weight: bold;
  font-size: 18px !important;
}
.v-input input,
.v-menu__activator {
  line-height: 25px;
}
.v-card__title--primary {
  padding: 10px;
}
.label {
  color: #f57c00;
  font-weight: bold;
  font-size: 14px !important;
}
.Head2 {
  color: black !important;
  font-size: 22px;
  font-weight: bold;
}
.diviverCustom {
  padding-bottom: 20px;
}
.v-select.v-text-field--enclosed:not(.v-text-field--single-line)
  .v-select__selections {
  padding-top: 0px;
}

.v-text-field--box>.v-input__control>.v-input__slot, .v-text-field--full-width>.v-input__control>.v-input__slot, .v-text-field--outline>.v-input__control>.v-input__slot {
    min-height: 40px;
}

.subHead2 {
  color: #292b2e;
  font-size: 16px;
  font-weight: bold;
}

.text-input {
  color: #f57c00;
}

.tableCus th {
  font-weight: bold !important;
  font-size: 18px !important;
  background-color: #ffa726;
}
.tableCus td {
  color: black !important;
  font-weight: bold !important;
  font-size: 16px !important;
  padding: 5px;
}

.tableCusMonth {
  border: 1px solid #37474f;
}
.tableCusMonth th {
  font-weight: bold !important;
  font-size: 14px !important;
  background-color: #ffe0b2;
  border: 1px solid #37474f;
  padding-top: 5px;
  padding-bottom: 5px;
}
.tableCusMonth td {
  color: black !important;
  font-weight: bold !important;
  font-size: 14px !important;
  padding-top: 5px;
  padding-bottom: 5px;
  padding-left: 10px;
  padding-right: 5px;
  height: 32px;
}
.tableCusMonth tbody tr:nth-child(even) {
  background: #e0e0e0;
}
.tableCusMonth tfoot {
  background: #ffe0b2;
}
  .fixed-header {
    height: 490px !important;
    display: flex;
    flex-direction: column;
    height: 100%;
  }
  .fixed-header table {
    table-layout: fixed;
  }
  .fixed-header th {
    position: sticky;
    top: 0;
    z-index: 5;
  }
  .fixed-header th:after {
    content: '';
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
  }
  .fixed-header tr{
    height: 1px;
  }
  .fixed-header .v-table__overflow {
    flex-grow: 1;
    flex-shrink: 1;
    overflow-x: hidden;
    overflow-y: auto;
  }
  .fixed-header .v-datatable.v-table {
    flex-grow: 0;
    flex-shrink: 1;
  }
  .fixed-header .v-datatable.v-table .v-datatable__actions {
    flex-wrap: nowrap;
  }
  .fixed-header .v-datatable.v-table .v-datatable__actions .v-datatable__actions__pagination {
    white-space: nowrap;
  }
  table.v-table tbody td:first-child, table.v-table tbody td:not(:first-child), table.v-table tbody th:first-child, table.v-table tbody th:not(:first-child), table.v-table thead td:first-child, table.v-table thead td:not(:first-child), table.v-table thead th:first-child, table.v-table thead th:not(:first-child) {
    padding: 0 10px;
  }
  .v-text-field--box input, .v-text-field--full-width input, .v-text-field--outline input {
    margin-top: 5px;
  }
  .v-autocomplete.v-text-field--enclosed:not(.v-text-field--solo):not(.v-text-field--single-line) .v-select__slot>input {
    margin-top: 0px;
    margin-bottom: 5px;
  }
  .v-textarea.v-text-field--box .v-text-field__prefix, .v-textarea.v-text-field--box textarea, .v-textarea.v-text-field--enclosed .v-text-field__prefix, .v-textarea.v-text-field--enclosed textarea {
    margin-top: 0px;
  }

  .tableCusColor tbody tr:nth-child(even)
  {
    background: #E0E0E0;
  }
  .tableCusColor tfoot {
    background: #ffa726;
  }
  .tableSumUse th {
    font-weight: bold !important;
    font-size: 16px !important;
    background-color: #ffa726;
    border: 0px solid black;
    color: #000 !important;
  }
  .tableSumUse td {
  color: black !important;
  font-weight: bold !important;
  font-size: 16px !important;
  padding: 5px;

  }
  .tableSumUse tbody tr:nth-child(even) {
    background: #E0E0E0;
  }
  .theme--light.v-table thead tr:first-child {
    border-bottom: 0;
  }
  .layout-button-search {
    margin-top: 1.1%
  }
</style>
